import {
  black,
  gray01,
  gray03,
  primary,
} from 'presentations/views/styles/color';
import Headline from 'presentations/views/components/atoms/Headline';
import {
  fontSize,
  fontWeight,
  mediaMax,
  spacing,
} from 'presentations/views/styles';
import styled from '@emotion/styled';

export interface Props {
  title: string;
  titleEn?: string;
  description?: string;
  className?: string;
}

export default function Component(props: Props) {
  return (
    <SectionHeadlineContainer className={props.className}>
      <SectionHeadlineContent>
        <SectionHeadline variant="h2">{props.title}</SectionHeadline>
        {props.titleEn && <SectionTitleEn>{props.titleEn}</SectionTitleEn>}
        {props.description && (
          <SectionDescription>{props.description}</SectionDescription>
        )}
      </SectionHeadlineContent>
    </SectionHeadlineContainer>
  );
}
const SectionHeadlineContainer = styled.div`
  margin-bottom: ${spacing(48)};
`;
const SectionHeadlineContent = styled.div``;
const SectionHeadline = styled(Headline)`
  text-align: center;
  font-size: ${fontSize(40)};
  font-weight: ${fontWeight('bold')};
  color: ${black};
  /* background: linear-gradient(
    73.82deg,
    #11d79b -24.74%,
    #11bdd7 16.25%,
    #0054d1 79.08%,
    #8e00d1 113.33%
  );
  -webkit-background-clip: text;
  color: transparent; */
  letter-spacing: -0.04em;
  ${mediaMax.tablet} {
    font-size: 6vw;
  }
`;
const SectionTitleEn = styled.div`
  color: ${primary};
  text-align: center;
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(18)};
  margin-top: 8px;
`;

const SectionDescription = styled.div`
  color: ${gray01};
  text-align: center;
  margin-top: 8px;
`;
